import db from "../db/database";
import {
    fetchFromBusinessCentral,
    sendToBusinessCentral,
} from "../utils/businessCentralUtils";
import { getPendingSync, isOnline } from "./syncService";

// Función para transformar un producto al formato esperado por Business Central
const transformProductForBC = (product) => {
    // Transformar el producto al formato esperado por BC
    const transformedProduct = {
        No_: product.No || "TEMP", // Si no tiene No, usamos TEMP para que BC asigne uno
        Description: product.description,
        Unit_Price: product.Unit_Price || 0, // Incluir el precio unitario
        PorIva: product.PorIva || 0, // Incluir el porcentaje de IVA
        Deleted: product.deleted,
    };

    // Crear el formato final esperado por el endpoint
    return {
        data: JSON.stringify({ Items: [transformedProduct] }),
    };
};

export const syncProducts = async () => {
    if (!isOnline()) {
        return false;
    }

    try {
        const pendingProducts = await getPendingSync("products");

        // Enviar productos pendientes uno por uno
        if (pendingProducts.length > 0) {
            console.log(`Sincronizando ${pendingProducts.length} productos pendientes...`);

            for (const product of pendingProducts) {
                try {
                    // Si el producto está marcado como eliminado, lo eliminamos directamente
                    if (product.deleted) {
                        await db.products.delete(product.id);
                        continue;
                    }

                    // Enviar producto individual a Business Central
                    const response = await sendToBusinessCentral(
                        "Importaciones_insertaProductos",
                        transformProductForBC(product),
                        true
                    );

                    // Verificar respuesta y actualizar el producto con el No asignado por BC
                    if (response && response.value) {
                        const productNo = response.value;

                        console.log(`Producto ${product.description} (ID: ${product.id}) sincronizado con No: ${productNo}`);

                        // Actualizar el producto local con el No de BC
                        await db.products.update(product.id, {
                            No: productNo,
                            lastModified: new Date(),
                            lastSynced: new Date(),
                            pendingSync: 0,
                        });

                    } else {
                        console.error(`Error al sincronizar producto ${product.id}: Respuesta inválida de BC`);
                    }
                } catch (error) {
                    console.error(`Error al sincronizar producto ${product.id}:`, error);
                }
            }
        }

        const localProducts = await db.products.toArray();

        // Obtener el último Source_Counter guardado
        let lastSourceCode = null;

        if (localProducts.length > 0) {
            lastSourceCode = localProducts.sort((a, b) => a.Source_Counter - b.Source_Counter)[localProducts.length - 1].Source_Counter;
        }

        console.log("lastSourceCode", lastSourceCode);

        // Obtener productos del servidor después de sincronizar los pendientes
        const serverProducts = await fetchFromBusinessCentral("ListaProductos" + (lastSourceCode ? `?$filter=Source_Counter gt ${lastSourceCode}` : ""));

        // Mapa para buscar productos locales por No rápidamente
        const localProductsByNo = {};
        localProducts.forEach(product => {
            if (product.No) {
                localProductsByNo[product.No] = product;
            }
        });

        if (serverProducts && serverProducts.length > 0) {

            // Actualizar productos existentes y añadir nuevos desde el servidor
            for (const serverProduct of serverProducts) {
                // Verificar si el producto ya existe localmente
                const localProduct = localProductsByNo[serverProduct.No];

                if (localProduct) {
                    // Actualizar producto existente si no está pendiente de sincronización
                    if (localProduct.pendingSync === 0) {
                        await db.products.update(localProduct.id, {
                            ...serverProduct,
                            description: serverProduct.Description,
                            Unit_Price: serverProduct.Unit_Price || 0,
                            PorIva: serverProduct.PorIva || 0,
                            lastModified: new Date(),
                            lastSynced: new Date(),
                        });
                    }
                } else {
                    // Añadir nuevo producto del servidor si no existe localmente
                    await db.products.add({
                        ...serverProduct,
                        No: serverProduct.No,
                        description: serverProduct.Description,
                        Unit_Price: serverProduct.Unit_Price || 0,
                        PorIva: serverProduct.PorIva || 0,
                        lastSynced: new Date(),
                        pendingSync: 0,
                        deleted: false,
                    });
                }
            }
        }

        return true;
    } catch (error) {
        console.error("Error al sincronizar productos:", error);
        return false;
    }
}; 